module.exports = __webpack_public_path__ + "static/media/alert-icon.9422e8d6.svg";